import React from "react";
import "./Bcont.css";
import bgImage from "../assets/imges/image.png";

const Bcont = () => {
    return (
        <div
            className="bcont"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
        <p className="text">દરેક વિભાગમાં ધોરણ પ્રમાણે દરેક પાઠનાં સ્વાધ્યાય, સ્વ-અધ્યયન પોથી, પુસ્તકની સોલ્યુશન સાથે PDF ઉપલબ્ધ છે. જે Download પણ કરી શકાશે. ઉપરાંત બધાંય પાઠ પ્રમાણે વીડિયો મટીરીયલ ઉપલબ્ધ છે.</p>
        </div>
    );
};

export default Bcont;
